import React from 'react'

import { Switch, Tooltip } from '@mui/material'
import { useCustomerUserUpsert } from 'features/customers/hooks/useCustomerUserUpsert'

import { EPermissions } from '@albacross/types'

type CustomerUserActiveToggleProps = {
  checked: boolean
  userId: number
  disabled?: boolean
  disabledTooltipText?: string
  isOutreachLicense?: boolean
}

const CustomerUserActiveToggle = ({
  userId,
  checked,
  isOutreachLicense = false,
  disabled = false,
  disabledTooltipText = undefined,
}: CustomerUserActiveToggleProps) => {
  const { mutate: upsertUser, isPending: isLoading } = useCustomerUserUpsert()

  const handleChange = (event: any) => {
    if (isOutreachLicense) {
      upsertUser({
        userId,
        permissions: {
          [EPermissions.OutreachSender]: event.target.checked,
        },
      })
    } else {
      upsertUser({
        userId,
      })
    }
  }

  const toggle = <Switch checked={checked} color="primary" disabled={disabled || isLoading} onChange={handleChange} />

  if (disabled && disabledTooltipText) {
    return (
      <Tooltip title={disabledTooltipText}>
        <span>{toggle}</span>
      </Tooltip>
    )
  }

  return toggle
}

export default CustomerUserActiveToggle
